import * as React from "react";
import { useRoute } from "react-router5";
import { getProductFilter, getProductParams } from "~/apps/pos/shared/services/qsfilter";
import Button from "~/common/elements/mobile/Button";
import { buttonSize, buttonStyle } from "~/common/elements/mobile/consts";
import Head from "~/common/layout/Head";
import { navigate } from "~/router";

const ProductsHeader = () => {
  const { route } = useRoute();
  const filter = getProductFilter(route.params);

  const handleCreate = () => {
    navigate("pos.admin.products.all-products.create", getProductParams(filter));
  };

  return (
    <Head headTitle={"Products"}>
      <Button title="Create product" buttonStyle={buttonStyle.SECN} buttonSize={buttonSize.LG} onClick={handleCreate} />
    </Head>
  );
};

export default ProductsHeader;
